import * as React from 'react';
import { FormGroup,  Switch, Typography, Box } from "@material-ui/core";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
const theme = createTheme({
  overrides: {
    MuiSwitch: {
      switchBase: {
        // Controls default (unchecked) color for the thumb
        color: "blue"
      },
      colorSecondary: {
        "&$checked": {
          // Controls checked color for the thumb
          color: "red"
        }
      },
      track: {
        // Controls default (unchecked) color for the track
        opacity: 0.7,
        backgroundColor: "grey",
        "$checked$checked + &": {
          // Controls checked color for the track
          opacity: 0.7,
          backgroundColor: "grey"
        }
      }
    }
  }
});
export default function SwitchMode(props) {
  return (
    <ThemeProvider theme={theme}>
    <FormGroup>
      <Box
      sx={{
        display:"flex",
        alignItems:"center",
        border:"2px solid #0c82da",
        borderRadius:"50px",
        p:"0 0.5rem",
        height:{xs:"30px", md:"36px"}
        }}
      >
      <Typography 
         style={{color:"#4A4A4A",fontSize:"14px"}}
      >
        Manual
      </Typography>
      <Switch  checked={props.checked} onChange={props.handleChange}/>
      <Typography
         style={{color:"#4A4A4A",fontSize:"14px"}}
      >
        Auto
      </Typography>
      </Box>
    </FormGroup>
    </ThemeProvider>
  );
}
